import { API_URLS } from '@helpers/api';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import CircleArrow from '@img/icons/circle-arrow.svg';
import Filters from '@stories/Components/Listings/Filters/Filters';
import Pagination from '@stories/Components/Listings/Pagination/Pagination';
import LoadingIndicator from '@stories/Components/Misc/LoadingIndicator/LoadingIndicator';
import qs from 'query-string';
import React from 'react';
import { ArrayParam, NumberParam, StringParam, useQueryParams, withDefault, } from 'use-query-params';
import DesktopSearch from '../Global/Header/DesktopSearch/DesktopSearch';
import { SearchResultsStyles as S } from './SearchResults.styles';
import { linkAria } from '@helpers/utils';
const SearchResults = ({ anchorId, initialResults, filters, sortOptions, search, totalResults, translations, }) => {
    const resultsRef = React.useRef(null);
    const [params, setParams] = useQueryParams(Object.assign({
        searchText: withDefault(StringParam, ''),
        filter: withDefault(ArrayParam, ['all']),
        sortBy: withDefault(StringParam, sortOptions.value),
        pageIndex: withDefault(NumberParam, 1),
        pageSize: withDefault(NumberParam, 10),
    }));
    const setFilter = (f) => {
        // Are you clicking on 'all' ? //
        if (f.name === 'all') {
            // Is 'all' already selected? //
            if (params.filter.some((x) => x === 'all')) {
                // Do nothing //
                return;
            }
            // Set 'all' and deselect all others //
            setParams({ filter: ['all'] });
            return;
        }
        // Must be clicking on something else //
        // Is it selected? //
        const filterIndex = params.filter.indexOf(f.name);
        const clone = [...params.filter];
        if (filterIndex > -1) {
            // Remove it //
            clone.splice(filterIndex, 1);
        }
        else {
            clone.push(f.name);
        }
        // Check 'all' isn't selected //
        const allIndex = params.filter.indexOf('all');
        if (allIndex > -1) {
            clone.splice(allIndex, 1);
        }
        setParams({ filter: clone });
    };
    const _sortOptions = {
        ...sortOptions,
        value: params.sortBy,
        onChange: (value) => setParams({ sortBy: value }, 'pushIn'),
    };
    const result = useApi({
        initialData: {
            items: initialResults,
            totalCount: totalResults,
        },
        url: `${API_URLS.GET_SEARCH_RESULTS}?${qs.stringify(params)}`,
    });
    return (React.createElement(S.Container, { id: anchorId },
        React.createElement(S.TopBanner, null,
            React.createElement(S.BackgroundElement, null),
            React.createElement(S.BannerContent, null,
                React.createElement(S.Title, null,
                    "Search Results for: ",
                    React.createElement("span", null, params.searchText)),
                React.createElement(S.SubTitle, null,
                    result.data && result.data.totalCount,
                    " Results for '",
                    params.searchText,
                    "'"),
                React.createElement(S.SearchWrapper, null,
                    React.createElement("span", null, "Search again"),
                    React.createElement(DesktopSearch, { ...search })))),
        React.createElement(S.ListingsSection, { spacing: "padding" },
            React.createElement(S.FiltersTop, null,
                React.createElement(S.TabFilters, null, filters.map((filter, i) => (React.createElement(S.FilterPill, { onClick: () => setFilter(filter), "data-active": params.filter.some((x) => x === filter.name), key: `SearchResults_Filter_${i}_${filter.name}`, type: "button" }, filter.label)))),
                React.createElement(Filters, { sortOptions: _sortOptions, viewButtonLabel: "" })),
            React.createElement(S.ResultsCount, null,
                "Showing ",
                result.data?.items && result.data.items.length,
                " of",
                ' ',
                result.data && result.data.totalCount,
                " Results for '",
                params.searchText,
                "'"),
            React.createElement(S.ResultsListing, { ref: resultsRef }, result.data?.items &&
                result.data.items.map((result, i) => (React.createElement(S.Result, { key: `SearchResults_${i}`, "aria-label": linkAria(result.cta.text ?? '', result.cta.target, translations && translations['lcci.link.newtab']), href: result.cta.url },
                    React.createElement(S.ResultContent, null,
                        React.createElement(S.ResultTitle, null, result.title),
                        result.subTitle && React.createElement(S.ResultSubtitle, null, result.subTitle),
                        result.description && React.createElement(S.ResultBody, null, result.description)),
                    React.createElement(CircleArrow, null))))),
            React.createElement(S.BackgroundCircle, null),
            result.data && result.data.totalCount > params.pageSize && (React.createElement(S.PaginationWrapper, null,
                React.createElement(Pagination, { pageIndex: params.pageIndex, pageSize: params.pageSize, totalCount: result.data.totalCount, onPageChange: (value) => {
                        setParams({ pageIndex: value }, 'pushIn');
                        scrollToTop();
                    } }),
                React.createElement("span", null,
                    params.pageSize,
                    " of ",
                    result.data && result.data.totalCount,
                    " Results")))),
        result.status === 'loading' && React.createElement(LoadingIndicator, { label: "Loading\u2026", layout: "fixed" })));
    function scrollToTop() {
        /** timeout required to ensure scrolling occurs on prev/next buttons */
        setTimeout(() => resultsRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
        }), 50);
    }
};
export default withQueryParams(SearchResults);
